/** Anything that does not fit in the Redux store can be stored here.
 * For instance:
 * - non-serializable stuff such as DOM elements, functions, files
 * - very big objects triggering performance issues or just Redux warnings
*/

const itemMap = {};
let nextItemId = 0;

export const saveNonSerializableItem = (item) => {
  itemMap[nextItemId] = item;
  return nextItemId++;
};
export const saveNonSerializableItemList = (itemList) => {
  return itemList.map(saveNonSerializableItem);
};
export const getNonSerializableItem = (id) => {
  return itemMap[id];
};
export const removeNonSerializableItem = (id) => {
  delete itemMap[id];
};
